import React, { forwardRef } from "react";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface FloatingDatePickerProps {
  label: string;
  value?: Date;
  onChange: (date: Date) => void;
  placeholder?: string;
  className?: string;
  minDate?: Date;
  maxDate?: Date;
}
interface DatePickerInputProps {
  value?: string;
  onClick?: () => void;
  placeholder?: string;
}

const DatePickerInput = forwardRef<HTMLInputElement, DatePickerInputProps>(
  ({ value, onClick, placeholder }, ref) => (
    <div
      className="input-group align-items-center border border-light rounded-1"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <input
        type="text"
        className="form-control border-0 pe-3 pt-4"
        ref={ref}
        value={value}
        placeholder={placeholder}
        readOnly
      />
      <i className="ms-1 bi bi-calendar-week pointer-events-none"></i>
    </div>
  )
);

DatePickerInput.displayName = "CustomInput";

export const FloatingDatePicker: React.FC<FloatingDatePickerProps> = ({
  label,
  value,
  onChange,
  placeholder = "",
  className = "",
  minDate = undefined,
  maxDate = undefined,
}) => {
  return (
    <Form.Floating className={`customDatePicker ${className}`}>
      <label className="form-label text-gray">{label}</label>
      <DatePicker
        selected={value}
        onChange={onChange}
        dateFormat="MM.dd.yyyy"
        placeholderText={placeholder}
        wrapperClassName="w-100"
        customInput={<DatePickerInput />}
        minDate={minDate}
        maxDate={maxDate}
      />
    </Form.Floating>
  );
};
